import { defineMessages } from "react-intl";

export default defineMessages({
  drills: {
    id: "PageCoachLibrary.drills",
    defaultMessage: "Drills",
  },
  trainings: {
    id: "PageCoachLibrary.trainings",
    defaultMessage: "Trainings",
  },
  admin: {
    id: "PageCoachLibrary.admin",
    defaultMessage: "Admin",
  },
  trainingDeleted: {
    id: "PageCoachLibrary.trainingDeleted",
    defaultMessage: "Training has been deleted",
  },
  drillDeleted: {
    id: "PageCoachLibrary.drillDeleted",
    defaultMessage: "Drill has been deleted",
  },
});
